<template>
  <div>
    <el-dialog :title="$t('system.notification_config')" class="notification-dialog" :close-on-click-modal="false" :visible.sync="dialogVisible" width="700px">
      <!-- 用户信息展示 -->
      <div v-if="userInfo" class="user-info-section">
        <div class="info-row">
          <span class="info-label">{{ $t('system.username') }}:</span>
          <span class="info-value">{{ userInfo.username }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">{{ $t('system.login_email') }}:</span>
          <span class="info-value">{{ userInfo.email }}</span>
        </div>
      </div>

      <div v-loading="loading" class="notification-container">
        <template v-for="item in notifySettingsList">
          <!-- 交易日报通知卡片 -->
          <el-card v-if="item.notify_type === 1" :key="item.user_notify_config_id" class="notification-card" shadow="never">
            <div slot="header" class="card-header">
              <div class="card-header-left">
                <div class="card-title">{{ $t('system.trade_daily_report_notification') }}</div>
                <div class="card-desc">{{ $t('system.send_trade_daily_notification') }}</div>
              </div>
              <div class="card-header-right">
                <span class="notify-label">{{ $t('system.email_notification') }}:</span>
                <el-switch
                  v-model="item.email_notify_status"
                  :active-value="1"
                  :inactive-value="2"
                  active-color="#13ce66"
                  @change="changeNotifyStatus($event, item)"
                />
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="left-label">{{ $t('system.scheduled_send') }}</div>
                <div class="right-control">
                  <!-- <el-time-picker v-model="form.tradeReportTime" format="HH:mm" value-format="HH:mm" placeholder="--:--" size="small" :disabled="!form.tradeEmailNotify" /> -->
                </div>
              </div>

              <div class="row action-row">
                <el-button type="text" @click="sendTestEmail(item.notify_type)">{{ $t('system.send_test_email') }}</el-button>
              </div>
            </div>
          </el-card>

          <!-- 余额预警通知卡片 -->
          <el-card v-if="item.notify_type === 2" :key="item.user_notify_config_id" class="notification-card" shadow="never">
            <div slot="header" class="card-header">
              <div class="card-header-left">
                <div class="card-title">{{ $t('system.balance_alert_notification') }}</div>
                <div class="card-desc">{{ $t('system.balance_alert_description') }}</div>
              </div>
              <div class="card-header-right">
                <span class="notify-label">{{ $t('system.email_notification') }}:</span>
                <el-switch
                  v-model="item.email_notify_status"
                  :active-value="1"
                  :inactive-value="2"
                  active-color="#13ce66"
                  @change="changeNotifyStatus($event, item)"
                />
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="left-label">{{ $t('system.event_trigger') }}</div>
                <div class="right-control">
                </div>
              </div>

              <div class="row">
                <div class="left-label">{{ $t('system.alert_amount') }}</div>
                <div class="right-control amount-control">
                  <el-input-number v-model="alertAmountInput" :min="0" :precision="0" :max="MAX_AMOUNT" controls-position="right" size="small" />
                  <el-button type="text" @click="addAlertAmount(item)">{{ $t('system.add_alert_amount') }}</el-button>
                  <el-button type="primary" size="mini" :loading="listLoading" @click="submitNotificationConfig(item)">{{ $t('components.save') }}</el-button>
                </div>
              </div>

              <div class="alert-list">
                <div v-if="!item.trigger_conditions || item.trigger_conditions.length === 0" class="empty">—</div>
                <el-tag v-for="(amt, idx) in item.trigger_conditions" :key="idx" closable @close="deleteAlertAmount(item, idx)" size="small">{{ amt }}</el-tag>
              </div>

              <div class="row action-row">
                <el-button type="text" @click="sendTestEmail(item.notify_type)">{{ $t('system.send_test_email') }}</el-button>
                <!-- <el-button type="primary" size="mini" :loading="listLoading" @click="submitNotificationConfig(item)">{{ $t('components.save') }}</el-button> -->
              </div>
            </div>
          </el-card>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMchNotifySetting, updateBalanceWarning, updateMchNotifySetting, testSendEmail } from '@/api/system/system'

export default {
  name: 'NotificationConfigModal',
  data() {
    this.MAX_AMOUNT = 10000000000
    return {
      dialogVisible: false,
      listLoading: false,
      userInfo: null,
      alertAmountInput: null,
      notifySettingsList: [
        // {
        //   user_notify_config_id: 1,
        //   notify_type: 1, // 1: 交易日报通知, 2: 余额预警通知
        //   email_notify_status: 2, // 1: 启用, 2: 禁用
        //   trigger_conditions: [] // 余额预警的触发金额列表
        // },
        // {
        //   user_notify_config_id: 2,
        //   notify_type: 2,
        //   email_notify_status: 2,
        //   trigger_conditions: []
        // }
      ],
      loading: false
    }
  },
  methods: {
    showModal(row) {
      this.dialogVisible = true
      this.notifySettingsList = []
      this.alertAmountInput = null
      this.userInfo = JSON.parse(JSON.stringify(row))
      this.getData()
    },
    getData() {
      this.loading = true
      getMchNotifySetting({
        merchant_user_id: this.userInfo.id
      }).then(res => {
        this.notifySettingsList = res.data || []
      }).finally(() => {
        this.loading = false
      })
    },

    // 发送测试邮件（模拟）
    sendTestEmail(type) {
      // type: 'trade' | 'balance'
      testSendEmail({
        merchant_user_id: this.userInfo.id,
        notify_type: type
      }).then(res => {
        this.$message.success(this.$t('system.send_test_email'))
      })
    },

    addAlertAmount(config) {
      let val = Number(this.alertAmountInput)
      if (!val && val !== 0) {
        this.$message.warning('Please enter an amount')
        return
      }
      val = String(val)
      if (!Array.isArray(config.trigger_conditions)) {
        config.trigger_conditions = []
      }
      if (config.trigger_conditions.length >= 3) {
        this.$message.warning('Maximum of 3 alert amounts allowed')
        return
      }
      if (config.trigger_conditions.includes(val)) {
        this.$message.warning('Amount already exists')
        return
      }
      config.trigger_conditions.push(val)
      config.trigger_conditions.sort((a, b) => a - b)
      this.alertAmountInput = null
    },

    submitNotificationConfig(config) {
      this.listLoading = true
      updateBalanceWarning({
        user_notify_config_id: config.user_notify_config_id,
        trigger_condition: config.trigger_conditions
      }).then(res => {
        this.$message.success(this.$t('components.success'))
      }).finally(() => {
        this.listLoading = false
      })
    },

    changeNotifyStatus(status, item) {
      const isEnabled = status === 1

      // 调用 API 更新通知状态
      updateMchNotifySetting({
        user_notify_config_id: item.user_notify_config_id,
        email_notify_status: isEnabled ? 1 : 2
      }).then(res => {
        this.$message.success(this.$t('components.success'))
      }).catch(err => {
        // 如果更新失败，恢复原来的状态
        item.email_notify_status = isEnabled ? 2 : 1
      })
    },

    deleteAlertAmount(config, idx) {
      config.trigger_conditions.splice(idx, 1)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.user-info-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 16px;
  border-left: 3px solid #409eff;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.info-label {
  font-size: 13px;
  font-weight: 500;
  color: #606266;
  min-width: 100px;
}

.info-value {
  font-size: 13px;
  color: #303133;
}

.notification-container{
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 0;
}

.notification-card{
  border-radius: 6px;
  /* padding: 0 16px 12px 16px; */
  background: #fff;
}

.card-header{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  /* padding: 12px 0 6px; */
}

.card-header-left{
  /* display: flex;
  align-items: center;
  justify-content: flex-start; */
}

.card-header-right{
  /* position: absolute;
  right: 20px;
  top: 18px; */
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-title{
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.card-desc{
  font-size: 12px;
  color: #909399;
  margin-top: 6px;
}

.card-body{
  /* padding: 8px 0 8px 0; */
}

.row{
  display: flex;
  align-items: center;
  gap: 16px;
  /* margin: 8px 0; */
}

.left-label{
  width: 120px;
  color: #606266;
  font-size: 13px;
}

.right-control{
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.amount-control .el-input-number{
  width: 140px;
}

.action-row{
  margin-top: 6px;
  justify-content: space-between;
}

.alert-list{
  margin-top: 8px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.dialog-footer{
  text-align: right;
}

.notify-label{
  color: #606266;
  font-size: 13px;
}

/* small responsive tweak */
@media (max-width: 720px){
  .left-label{ width: 110px }
}
</style>
